<template>
	<div class="home">
		<hero/>
		<news/>
		<notification-bar/>
	</div>
</template>

<script>
import hero from "./hero.vue";
import news from "@/components/news/index.vue";
import notificationBar from "./notification-bar.vue";

export default {
	components: {hero, news, notificationBar}
}
</script>

<style lang="scss" scoped>
.home {

}
</style>
